import React, { useState } from 'react';
import { FieldArray } from 'redux-form';
import classNames from 'classnames';
import styles from './assets/program-array-fields.module.scss';
import RenderLongTermArray from './RenderLongTermArray';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        setIsManualChangeValue,
        isManualChangeValue,
        setTargetManualChangeValue,
        targetManualChangeValue,
        programBookId,
    } = props;
    return (
        <ul className={classNames(styles.ul)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                    setIsManualChangeValue={setIsManualChangeValue}
                    isManualChangeValue={isManualChangeValue}
                    setTargetManualChangeValue={setTargetManualChangeValue}
                    targetManualChangeValue={targetManualChangeValue}
                    programBookId={programBookId}
                />
            ))}
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
    setIsManualChangeValue: (it: boolean) => void;
    isManualChangeValue: any;
    setTargetManualChangeValue: (it: string) => void;
    targetManualChangeValue: any;
    programBookId: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    index,
    fields,
    isLast,
    isNotFirst,
    setIsManualChangeValue,
    isManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    programBookId,
}) => {
    const row = fields.get(index);
    const [isHide, setHide] = useState(true);
    const creditStyle = {
        display: 'none',
    };
    return (
        <li
            style={+row.status === 2 ? creditStyle : {}}
            className={classNames('w-100', styles.itemLi, +row.isHidden == 1 ? styles.hiddenDomain : '')}
            key={index}
        >
            <div className={classNames(styles.treeview__level, styles.domainWrap)} data-level="DO">
                <span onClick={() => setHide(!isHide)} className={classNames(styles.leveltitle)}>
                    {row.title}
                    {isHide && row?.values?.length ? (
                        <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faChevronDown} />
                    ) : (
                        <FontAwesomeIcon style={{ marginLeft: '10px' }} icon={faChevronUp} />
                    )}
                </span>
                <div>
                    {!isHide ? (
                        <FieldArray
                            setIsManualChangeValue={setIsManualChangeValue}
                            isManualChangeValue={isManualChangeValue}
                            setTargetManualChangeValue={setTargetManualChangeValue}
                            targetManualChangeValue={targetManualChangeValue}
                            name={`${member}.values`}
                            component={RenderLongTermArray}
                            programBookId={programBookId}
                        />
                    ) : null}
                </div>
            </div>
        </li>
    );
};
export default RenderFieldArray;
